<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      title="门票详情"
      width="80%"
      @close="close"
    >
      <el-row>
        <el-col :span="5">门票名称:</el-col>
        <el-col :span="19">{{ showForm.title }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="5">类型:</el-col>
        <el-col :span="19">
          <el-tag v-if="showForm.typehood===1">日票</el-tag>
          <el-tag v-if="showForm.typehood===2">期票</el-tag>
          <el-tag v-if="showForm.typehood===3">年卡</el-tag>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">默认价格:{{showForm.basic&&showForm.basic.price.defaultPrice}}</el-col>
        <el-col :span="12">
          默认日库存:{{showForm.basic&&showForm.basic.stock.defaultStock}}
        </el-col>
      </el-row>
      <!-- 暂时没有tagList -->
      <!-- <el-row>
        <el-col :span="5">标签:{{showForm.basic&&showForm.basic.lng}}</el-col>
        <el-col :span="19"><el-tag v-for="(item,index) of showForm.tags" :key="index">{{item.title}}</el-tag></el-col>
      </el-row> -->
      <el-row>
        <el-col :span="5">购买须知</el-col>
        <el-col :span="15">
          {{showForm.basic&&showForm.basic.note}}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">图文说明：</el-col>
        <el-col :span="15">
          <div
            class="rich-box"
            v-html="showForm.basic && showForm.basic.text"
          ></div>
        </el-col>
      </el-row>
      <template #footer>
        <el-button @click="close">关闭</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { find } from '@/api/ticket'
export default {
  name: 'TicketDetail',
  emits: ['fetch-data'],
  data() {
    return {
      showForm: {},
      dialogFormVisible: false,
    }
  },
  methods: {
    async show(row) {
      const ticketId = row.ticketId
      const data = await find({
        ticketId,
      })
      this.showForm = data
      this.dialogFormVisible = true
    },
    close() {
      this.dialogFormVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.rich-box {
  overflow: auto;
  max-height: 800px;
}
// .rich-box img{
//     // max-width: 600px !important;
// }
.p-avatar {
  width: 240px;
  height: 160px;
}
.e-carousel {
  width: 240px;
}
.el-row {
  padding: 14px 0;
}
.ml-10 {
  margin-left: 10px;
}
</style>
